import Hero from "../components/hero/Hero";
import AboutSection from "../components/about/AboutSection";
import DirectAccess from "../components/access/DirectAccess";
import NoGatekeepers from "../components/access/NoGatekeepers";
import GlobalReach from "../components/global/GlobalReach";
import Insights from "../components/insights/Insights";
import VideoSection from "../components/media/VideoSection";
import ContactForm from "../components/contact/ContactForm";
import WhatsAppButton from "../components/contact/WhatsAppButton";

const Home = () => {
  return (
    <>
      <Hero />
      <AboutSection />
      <DirectAccess />
      <NoGatekeepers />
      <GlobalReach />
      <Insights />
      <VideoSection />
      <ContactForm />
      <WhatsAppButton />
    </>
  );
};

export default Home;